export const DATA_SOURCE_TYPES = {
  CUSTOM: "CUSTOM",
  TODDLE: "TODDLE",
};

export const DATA_GRID_CELL_TYPES = {
  DROPDOWN: "dropdown",
  ICON: "icon",
  TAG: "tag",
  SKELETON: "skeleton",
  TOGGLE: "toggle",
  LABEL: "label",
};

export const DATA_GRID_COLUMN_TYPES = {
  GRADE_LEVEL: "GRADE_LEVEL",
  ASSOCIATED_SCHOOL: "ASSOCIATED_SCHOOL",
  ACADEMIC_YEARS: "ACADEMIC_YEARS",
  GRADING_PERIODS: "GRADING_PERIODS",
  SHOW_IN_TRANSCRIPT: "SHOW_IN_TRANSCRIPT",
  MODIFY_DISPLAY_SEQUENCE: "MODIFY_DISPLAY_SEQUENCE",
  DELETE: "DELETE",
};

export const DEFAULT_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.GRADE_LEVEL,
  DATA_GRID_COLUMN_TYPES.ASSOCIATED_SCHOOL,
  DATA_GRID_COLUMN_TYPES.ACADEMIC_YEARS,
  DATA_GRID_COLUMN_TYPES.GRADING_PERIODS,
  DATA_GRID_COLUMN_TYPES.SHOW_IN_TRANSCRIPT,
  DATA_GRID_COLUMN_TYPES.MODIFY_DISPLAY_SEQUENCE,
  DATA_GRID_COLUMN_TYPES.DELETE,
];

export const COLUMN_HEADER_PROPERTIES = t => ({
  [DATA_GRID_COLUMN_TYPES.GRADE_LEVEL]: {
    title: t("common:grade_level"),
    suffixIcon: {
      iconName: "SettingsOutlined",
      isAlignedToRightEnd: true,
      tooltip: t("transcript:configure_custom_label", {
        label: t("common:grade_levels"),
      }),
    },
  },
  [DATA_GRID_COLUMN_TYPES.SHOW_IN_TRANSCRIPT]: {
    title: t("transcript:show_in_transcript"),
    width: 140,
  },
  [DATA_GRID_COLUMN_TYPES.ASSOCIATED_SCHOOL]: {
    title: t("transcript:associated_school"),
    suffixIcon: {
      iconName: "SettingsOutlined",
      isAlignedToRightEnd: true,
      tooltip: t("transcript:configure_custom_label", {
        label: t("common:school_plural"),
      }),
    },
  },
  [DATA_GRID_COLUMN_TYPES.ACADEMIC_YEARS]: {
    title: t("common:academic_year_plural"),
    suffixIcon: {
      iconName: "SettingsOutlined",
      isAlignedToRightEnd: true,
      tooltip: t("transcript:configure_custom_label", {
        label: t("common:academic_year_plural"),
      }),
    },
  },
  [DATA_GRID_COLUMN_TYPES.GRADING_PERIODS]: {
    title: t("transcript:grading_periods_to_display"),
    suffixIcon: {
      iconName: "SettingsOutlined",
      isAlignedToRightEnd: true,
      tooltip: t("transcript:configure_custom_label", {
        label: t("common:grading_period_plural"),
      }),
    },
  },
  [DATA_GRID_COLUMN_TYPES.MODIFY_DISPLAY_SEQUENCE]: {
    title: "",
    width: 104,
  },
  [DATA_GRID_COLUMN_TYPES.DELETE]: {
    title: "",
    width: 60,
  },
});

export const PLACEHOLDERS_BY_COLUMN_ID = t => ({
  [DATA_GRID_COLUMN_TYPES.ASSOCIATED_SCHOOL]: t("common:select_with_label", {
    label: t("common:school_name"),
  }),
  [DATA_GRID_COLUMN_TYPES.ACADEMIC_YEARS]: t("common:select_with_label", {
    label: t("common:academic_year"),
  }),
  [DATA_GRID_COLUMN_TYPES.GRADING_PERIODS]: t("common:select_with_label", {
    label: t("common:grading_period_plural"),
  }),
});

export const CUSTOM_SUFFIX = t => [
  {
    type: "tag",
    color: "yellow",
    value: t("common:custom"),
    height: 20,
    width: 52,
  },
];

export const DROPDOWN_COLUMN_CONFIG = {
  [DATA_GRID_COLUMN_TYPES.ASSOCIATED_SCHOOL]: {
    getValueFrom: "school",
    labelKey: "name",
    validInputsKey: "schoolValidInput",
  },
  [DATA_GRID_COLUMN_TYPES.ACADEMIC_YEARS]: {
    getValueFrom: "academicYear",
    labelKey: "label",
    validInputsKey: "academicYearValidInput",
  },
};

export const MODAL_NAMES = {
  COPY_TO_OTHER_STUDENTS: "COPY_TO_OTHER_STUDENTS",
  CONFIGURATION_WARNING: "CONFIGURATION_WARNING",
};
